module.exports = __webpack_public_path__ + "static/media/swap-white.dd711889.svg";